module.exports = __webpack_public_path__ + "static/media/backup_04.8bfc7a2b.svg";